import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'span-button',
	templateUrl: "./span-button.html",
	styles: [require("./span-button.scss")]
})

export class SpanButton {
	@Input() iconCssClass: string;
	@Input() buttonText: string;
	@Output() buttonClicked =  new EventEmitter<void>();
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/span-button/span-button.component.ts